
  var _styles = {
  "phx-poi-lis--top-area-normal": {
    "width": "4.56rem",
    "height": "3.41333rem"
  },
  "phx-poi-lis--card-container-normal": {
    "width": "4.56rem",
    "height": "6.92rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "phx-poi-lis--top-area-small": {
    "width": "4.18667rem",
    "height": "3.13333rem"
  },
  "phx-poi-lis--card-container-small": {
    "width": "4.18667rem",
    "height": "6.53333rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "phx-poi-lis--book-info-container": {
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "0.10667rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "phx-poi-lis--book-info": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "marginLeft": "0.08rem"
  },
  "phx-poi-lis--head-icon": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "paddingTop": "0.10667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.10667rem",
    "paddingLeft": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-image-container": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "2rem",
    "height": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-image": {
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "phx-poi-lis--head-icon-text": {
    "fontSize": "0.32rem"
  },
  "phx-poi-lis--poi-name": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "phx-poi-lis--score-rating-user-review-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "phx-poi-lis--score": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(6,68,155)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "phx-poi-lis--rating": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "phx-poi-lis--user-review": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "whiteSpace": "nowrap",
    "color": "rgb(0,64,153)"
  },
  "phx-poi-lis--discount-content": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "marginRight": "0.08rem",
    "textAlign": "left"
  },
  "phx-poi-lis--sales-count-content": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "phx-poi-lis--sales-count-container": {
    "background": "#fff1ec",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "phx-poi-lis--discount-container": {
    "background": "#ff4700",
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.05333rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "phx-poi-lis--small-tag-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start"
  },
  "phx-poi-lis--prev": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "phx-poi-lis--price": {
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem"
  },
  "phx-poi-lis--behind": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0
  },
  "phx-poi-lis--buy-button-text": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "phx-poi-lis--sell-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "phx-poi-lis--origin-price": {
    "textDecoration": "line-through",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.34667rem"
  },
  "phx-poi-lis--price-area": {
    "position": "relative"
  },
  "phx-poi-lis--price-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "phx-poi-lis--buy-button-wrap": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgb(255,119,0)",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "30px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.32rem"
  },
  "phx-poi-lis--bottom-area": {
    "width": "100%",
    "height": "3.50667rem",
    "paddingTop": "0.10667rem",
    "paddingRight": "0.24rem",
    "paddingBottom": "0.32rem",
    "paddingLeft": "0.24rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "phx-poi-lis--position-info": {
    "fontSize": "0.24rem",
    "fontFamily": "PingFangSC-Regular",
    "color": "rgb(119,119,119)",
    "textDecoration": "none",
    "marginBottom": "0.02667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-bold2', 'url("https://s0.meituan.net/bs/tempfs/file/dongxiaoxue/MTfin-bold2.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  